import {Button} from '@freckle/educator-materials/ts/components/button'
import {Modal, Header, Body, Footer} from '@freckle/educator-materials/ts/components/modal'
import {Table} from '@freckle/educator-materials/ts/components/table/table'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {cellFromRow} from '@freckle/educator-materials/ts/logic/table/table'
import type {UnmanagedCourseT} from '@freckle/school/ts/common/models/unmanaged-course'

type Props = {
  show: boolean
  onHide: () => void
  courses: Array<UnmanagedCourseT>
}

type Formatted<A> = {
  teacherFullName: string
  source: string
} & A

export function CourseSummaryModal(props: Props) {
  const {show, onHide, courses} = props
  const {t} = useSafeTranslation()

  return (
    <Modal show={show} onHide={onHide}>
      <Header onClickClose={onHide}>
        {t('COURSE_SUMMARY_MODAL_TITLE', {numCourses: courses.length})}
      </Header>

      <Body data-test="course-summary-modal">
        <Table
          data={formatNames(courses)}
          columns={[
            {
              Header: t('COURSE_SUMMARY_MODAL_TABLE_HEADER_COURSE_NAME'),
              accessor: d => d.name,
            },
            {
              Header: t('COURSE_SUMMARY_MODAL_TABLE_HEADER_COURSE_ID'),
              accessor: d => d.id,
            },
            {
              Header: t('COURSE_SUMMARY_MODAL_TABLE_HEADER_TEACHER_NAME'),
              accessor: d => d.teacherFullName,
            },
            {
              Header: t('COURSE_SUMMARY_MODAL_TABLE_HEADER_SOURCE'),
              accessor: d => d.source,
            },
            {
              Header: t('COURSE_SUMMARY_MODAL_TABLE_HEADER_CREATED_AT'),
              accessor: d => d.createdAt,
              Cell: cellFromRow(({createdAt: date}) => (
                <>{t('COURSE_SUMMARY_MODAL_TABLE_CREATED_AT_DATE', {date})}</>
              )),
            },
          ]}
        />
      </Body>

      <Footer>
        <Button onClick={onHide}>{t('COURSE_SUMMARY_MODAL_BUTTON_CLOSE')}</Button>
      </Footer>
    </Modal>
  )
}

const formatNames = (courses: Array<UnmanagedCourseT>): Array<Formatted<UnmanagedCourseT>> =>
  courses.map(course => {
    const teacherFullName = `${course.teacherFirstName} ${course.teacherLastName}`
    const sourceObj = {source: 'Teacher Uploaded'}
    return {teacherFullName, ...sourceObj, ...course}
  })
